import React, { useState } from "react";

import "./Switch.css";

var Switch = function Switch(props) {
  var classes = [];

  if (props.color) classes.push(props.color);
  if (props.size) classes.push("switch-" + props.size);

  return React.createElement(
    "span",
    { className: "switchContainer" },
    React.createElement(
      "label",
      { className: "switch " + classes.join(" ") },
      React.createElement("input", {
        id: props.id,
        name: props.name,
        type: "checkbox",
        defaultChecked: props.isChecked,
        onClick: props.onClick
      }),
      React.createElement("span", { className: "slider round" })
    ),
    props.label ? React.createElement(
      "label",
      { htmlFor: props.id },
      props.label
    ) : ""
  );
};

export default Switch;